import { useState } from "react";
import { Form } from "react-bootstrap"
import helpIcon from "../../assets/images/help.png"
import AlertModal from "./AlertModal";

const FileUpload = (props) => {
    const [showFileTypes, setShowFileTypes] = useState(false);
    const handleShowFileTypes = () => {
        setShowFileTypes(true);
    }

    const handleCloseFileTypes = () => {
        setShowFileTypes(false);
    }
    return (<>
    <Form.Label>
        <span>
        Issue/Request File
        
        <img className="helpIcon" onClick={handleShowFileTypes} alt="help" src={helpIcon}/>
        </span>
    </Form.Label>
    <Form.Group controlId="formFile" className="mb-3">
        <Form.Control
        {...props.register("issueFile", {
            validate: {
            lessThan50: v => (v[0]?.size || 0) < 50000000 || "Max of 50mb",
            acceptedFormats: files =>
                ([
                'image/jpeg',
                'image/png',
                'image/gif',
                'application/pdf',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'video/mp4',
                'video/quicktime',
                'application/vnd.ms-powerpoint',
                'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                ].includes(
                files[0]?.type
                ) || files.length === 0) || 'File type is not allowed. Click ? to see the allowed files',
            },
        })}
        type="file"
        />
        {props?.errors?.issueFile?.message && <Form.Control.Feedback type="invalid" style={props?.errors?.issueFile?.message ? {display:'block'} : { display: 'none'}}>{props?.errors?.issueFile?.message}</Form.Control.Feedback>}
    </Form.Group>
    <AlertModal
        show={showFileTypes}
        handleClose={handleCloseFileTypes}
        modalTitle={'Allowed File Types'}
        modalBody={<>
          <h2>Text/Document Files</h2>
          <p>.PDF (Portable Document Format File)</p>
          <p>.DOCX (Microsoft Word Open XML Document)</p>
          <h2>Art/Photography Files</h2>
          <p>.JPG (JPEG Image File)</p>
          <p>.GIF (Graphical Interchange Format File)</p>
          <p>.PNG (Portable Network Graphic)</p>
          <h2>Video Files</h2>
          <p>.MP4 (MPEG-4 Video File)</p>
          <p>.MOV (Apple QuickTime Movie)</p>
          <h2>Other Files</h2>
          <p>.PPT (PowerPoint Presentation)</p>
          <p>.XLSX (Microsoft Excel Open XML Spreadsheet)</p>
        </>}
        handleConfirmButton={handleCloseFileTypes}
        confirmButton={'Close'}>
      </AlertModal>
    </>)
}

export default FileUpload;